"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var vue_property_decorator_1 = require("vue-property-decorator");
var campaignFactory_model_1 = require("../../../model/campaignFactory.model");
var ConsentGrantsFormComponent = (function (_super) {
    __extends(ConsentGrantsFormComponent, _super);
    function ConsentGrantsFormComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsentGrantsFormComponent.prototype.data = function () {
        return {
            channels: campaignFactory_model_1.CONSENT_CHANNELS
        };
    };
    Object.defineProperty(ConsentGrantsFormComponent.prototype, "statusItems", {
        get: function () {
            var _this = this;
            return campaignFactory_model_1.CONSENT_SIMULATION_STATUSES.map(function (status) { return ({
                value: status,
                text: _this.$tc("campaign_factory.test.consent_grants.status." + status)
            }); });
        },
        enumerable: false,
        configurable: true
    });
    ConsentGrantsFormComponent.prototype.addGrant = function () {
        var channels = {};
        campaignFactory_model_1.CONSENT_CHANNELS.forEach(function (channel) {
            channels[channel] = false;
        });
        this.grants.push({ advertiserId: '', channels: channels, states: {} });
    };
    ConsentGrantsFormComponent.prototype.removeGrant = function (grantIndex) {
        this.grants.splice(grantIndex, 1);
    };
    ConsentGrantsFormComponent.prototype.stateOf = function (grant, channel) {
        var state = grant.states ? grant.states[channel] : undefined;
        if (state !== undefined) {
            return state.status;
        }
        return grant.channels[channel] ? 'granted' : 'none';
    };
    ConsentGrantsFormComponent.prototype.grantedAtOf = function (grant, channel) {
        var state = grant.states ? grant.states[channel] : undefined;
        return (state && state.grantedAt) || '';
    };
    ConsentGrantsFormComponent.prototype.withdrawnAtOf = function (grant, channel) {
        var state = grant.states ? grant.states[channel] : undefined;
        return (state && state.withdrawnAt) || '';
    };
    ConsentGrantsFormComponent.prototype.setState = function (grant, channel, status) {
        if (grant.states === undefined) {
            vue_1.default.set(grant, 'states', {});
        }
        grant.channels[channel] = status === 'granted';
        var grantedAt = this.grantedAtOf(grant, channel) || undefined;
        if (status === 'none' || (status === 'granted' && !grantedAt)) {
            vue_1.default.delete(grant.states, channel);
        }
        else {
            vue_1.default.set(grant.states, channel, { status: status, grantedAt: grantedAt });
        }
    };
    ConsentGrantsFormComponent.prototype.setGrantedAt = function (grant, channel, grantedAt) {
        if (grant.states === undefined) {
            vue_1.default.set(grant, 'states', {});
        }
        vue_1.default.set(grant.states, channel, {
            status: this.stateOf(grant, channel),
            grantedAt: grantedAt || undefined,
            withdrawnAt: this.withdrawnAtOf(grant, channel) || undefined
        });
    };
    ConsentGrantsFormComponent.prototype.setWithdrawnAt = function (grant, channel, withdrawnAt) {
        vue_1.default.set(grant.states, channel, {
            status: 'withdrawn',
            grantedAt: this.grantedAtOf(grant, channel) || undefined,
            withdrawnAt: withdrawnAt || undefined
        });
    };
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", Array)
    ], ConsentGrantsFormComponent.prototype, "grants", void 0);
    ConsentGrantsFormComponent = __decorate([
        vue_class_component_1.default
    ], ConsentGrantsFormComponent);
    return ConsentGrantsFormComponent;
}(vue_1.default));
exports.default = ConsentGrantsFormComponent;
